// context/TranslationContext.js
import { createContext, useContext } from 'react'

const TranslationContext = createContext()

export const TranslationProvider = ({ children, t }) => {
    const translateField = (field, translationPath) => {
        const translated = { ...field }

        // Translate main label
        translated.label = t(`fields.${translationPath}.fields.${field.name}`)

        // if checkbox-group, don't translate
        if (field.type === 'checkbox-group' && field.options) {
            return field
        }
        // Translate regular select options
        else if (field.options) {
            translated.options = field.options.map(option => ({
                ...option,
                label:
                    typeof option.label === 'string'
                        ? t(option.label)
                        : t(`fields.${translationPath}.options.${field.name}.${option.value}`),
            }))
        }

        // Translate description
        if (typeof field.description === 'string') {
            translated.description = t(field.description)
        } else if (field.description) {
            translated.description = t(`fields.${translationPath}.descriptions.${field.name}`)
        }

        return translated
    }

    const translateFields = (fields, translationPath) => {
        return fields.map(field => {
            const translated = translateField(field, translationPath)

            translated.label = t(`fields.${translationPath}.fields.${field.name}`)

            // Handle group fields
            if (field.type === 'group' && field.fields) {
                // Construct the new translation path for nested fields
                const groupPath = `${translationPath}.group.${field.name}`
                translated.fields = translateFields(field.fields, groupPath)
            }

            return translated
        })
    }

    return (
        <TranslationContext.Provider value={{ t, translateFields }}>
            {children}
        </TranslationContext.Provider>
    )
}

// Custom hook to access the context
export const useTranslationService = () => {
    const context = useContext(TranslationContext)
    if (!context) {
        throw new Error('useTranslationService must be used within a TranslationProvider')
    }
    return context
}

// Named export for direct usage if needed
export { TranslationContext }
